const appSettings = window.AppSettings;

export default appSettings;